<template>
  <q-layout view="hHh lpR fFf">
    <q-header bordered class="bg-white text-dark">
      <q-toolbar class="min-height: 48px">
        <img @click="homeClick" class="q-ml-xs" src="/ncl-logo.svg" />
        <q-space />
        <div class="row">
          <q-btn size=".8em" flat round icon="share" @click="share" />
          <q-btn
            class="q-ml-md"
            v-if="agent !== null"
            flat
            round
            size=".8em"
            icon="phone"
            @click="show_agent_card"
          />
          <q-btn
            v-if="!hideMenu"
            class="q-ml-md"
            dense
            flat
            round
            icon="list"
            @click="right = !right"
          />
        </div>
      </q-toolbar>
    </q-header>

    <q-drawer
      :width="screenWidth"
      v-model="right"
      side="right"
      overlay
      behavior="desktop"
      bordered
    >
      <q-list class="q-pt-md" separator padding>
        <q-item-label header>INDEX</q-item-label>
        <q-item
          v-ripple
          v-for="item in directory"
          :key="item.title"
          :clickable="item.index !== null"
          @click="menuClick(item)"
        >
          <q-item-section v-html="item.title"></q-item-section>
          <q-item-section class="q-mr-xs" side>{{
            item.index !== null ? item.index + 1 : ""
          }}</q-item-section>
        </q-item>
      </q-list>
    </q-drawer>

    <q-page-container>
      <q-page>
        <q-carousel
          height="calc(100vh - 100px)"
          swipeable
          animated
          v-model="page"
          @transition="transition"
          infinite
          :transition-duration="100"
        >
          <q-carousel-slide
            v-for="(slide, index) in cards"
            :key="slide"
            style="padding: 0"
            :name="index"
          >
            <q-scroll-area
              :id="'scrollArea' + index"
              style="height: calc(100vh - 100px)"
            >
              <img style="width: 100%" :src="`/images/${slide}`" />
            </q-scroll-area>
          </q-carousel-slide>
        </q-carousel>
      </q-page>
    </q-page-container>

    <q-footer bordered class="text-dark" style="background-color: #fafafa">
      <div
        style="min-height: 48px"
        class="q-px-lg row justify-between items-center content-center full-width"
      >
        <div class="col-3">
          <q-btn
            flat
            dense
            label="Back"
            padding="none"
            color="primary"
            :class="page === 0 ? ' invisible' : ''"
            @click="previous"
          />
        </div>
        <div class="text-caption text-center">
          {{ page + 1 }} / {{ cards.length }}
        </div>
        <div class="col-3 text-right">
          <q-btn
            flat
            dense
            label="Next"
            padding="none"
            color="primary"
            :class="page === cards.length - 1 ? ' invisible' : ''"
            @click="next"
          />
        </div>
      </div>
    </q-footer>
    <q-dialog v-model="showAgentCard">
      <q-card class="q-py-lg q-px-sm" style="border-radius: 4px; width: 90%">
        <q-card-section
          class="q-pt-md q-pb-lg q-px-lg column justify-evenly items-center q-gutter-y-lg"
        >
          <div>
            <img src="/ncl-card-logo.svg" />
          </div>
          <div
            class="q-px-lg q-pt-lg"
            style="letter-spacing: 1px; color: #0071a6"
          >
            <b>{{ agent.callmeAt }}</b>
          </div>
          <div v-if="agentName !== ''" class="q-pt-sm column items-center">
            <div
              class="text-uppercase"
              style="letter-spacing: 1px; color: #424242; font-size: 24px"
            >
              {{ agentName }}
            </div>
            <div style="color: #757575">
              {{ agent.title }}
            </div>
          </div>
          <div
            v-if="agentName !== ''"
            class="q-pb-xs q-pt-sm"
            style="border-bottom: 1px solid #ccc; height: 1px; width: 100%"
          ></div>
          <div>
            <a :href="'tel:' + agent.phoneNumber" @click="onclickPhoneLink">{{
              agent.phoneNumber
            }}</a>
          </div>
          <div
            style="border-bottom: 1px solid #ccc; height: 1px; width: 100%"
          ></div>
          <div>
            <a
              v-if="agent?.website"
              :href="agent.website"
              @click="onclickWebSiteLink"
              target="_blank"
              >{{ agent.website }}</a
            >
            <a
              v-if="!agent?.website"
              :href="'mailto:' + agent.email"
              @click="onclickEmailLink"
              >{{ agent.email }}</a
            >
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-layout>
</template>

<script>
import json from "../../public/data.json";
import { useQuasar } from "quasar";
import { Platform } from "quasar";
import anime from "animejs";

let $q = null;
const breakpointRatio = 7 / 16;
const mobileOrDesktop = (uri, query = {}) => {
  let layout = "mobile";
  if (Platform.is.desktop) {
    layout = "desktop";
  } else {
    const screenRatio = window.innerWidth / window.innerHeight;
    ///alert(window.innerWidth + "," + window.innerHeight);
    if (screenRatio > breakpointRatio) {
      layout = "mobile";
    }
  }
  if (query?.force) {
    layout = query.force === "desktop" ? "desktop" : "mobile";
    delete query.force;
  }
  if (layout === "desktop") {
    // redirect desktop
    top.document.location = `/desktop${uri}`;
  }
};

export default {
  name: "MainLayout",
  data() {
    return {
      right: false,
      page: 0,
      directory: json.directory,
      pages: json.images,
      showAgentCard: false,
      agent: null,
    };
  },
  computed: {
    hideMenu: {
      get() {
        return this.agent?.highlights && this.agent.highlights === true;
      },
    },
    cards: {
      get() {
        if (!this.agent?.highlights) return this.pages;
        if (this.agent.highlights) {
          const included = [
            1, 2, 3, 7, 13, 15, 49, 156, 157, 159, 162, 163, 166, 168, 173, 174,
          ];
          return this.pages.filter((item, index) => {
            return included.includes(index + 1);
          });
        } else {
          return this.pages;
        }
      },
    },
    screenWidth: {
      get() {
        return window.innerWidth;
      },
    },
    agentName: {
      get() {
        if (this.agent?.nickname && this.agent.nickname.length > 0) {
          return this.agent.nickname;
        } else {
          if (this.agent?.firstName && this.agent?.lastName) {
            return this.agent.firstName + " " + this.agent.lastName;
          } else {
            return "";
          }
        }
      },
    },
  },
  created() {
    /*console.log(
      btoa(
        JSON.stringify({
          firstName: "Jorge",
          lastName: "del Prado",
          phoneNumber: "+5491164218476",
          email: "delpradojorge@gmail.com",
          nickname: "George",
          link: "https://ncl-pov.link/rur",
        })
      )
    );
    eyJmaXJzdE5hbWUiOiJKb3JnZSIsImxhc3ROYW1lIjoiZGVsIFByYWRvIiwicGhvbmVOdW1iZXIiOiIrNTQ5MTE2NDIxODQ3NiIsImVtYWlsIjoiZGVscHJhZG9qb3JnZUBnbWFpbC5jb20iLCJuaWNrbmFtZSI6Ikdlb3JnZSIsImxpbmsiOiJodHRwczovL25jbC1wb3YubGluay9ydXIifQ==
    */
    if (this.$route.path.indexOf("desktop") === -1) {
      mobileOrDesktop(this.$route.path, this.$route.query);
    }
    if (this.$route.params?.agent) {
      if (this.$route.params.agent === "highlights") {
        this.agent = {
          highlights: true,
          brand: true,
          callmeAt: "PLEASE CALL US AT:",
          phoneNumber: "+1(877)416-9722",
          website: "https://ncl.com",
        };
      } else {
        this.agent = JSON.parse(atob(this.$route.params.agent));
        window.sendEventToGA({
          event: "register_agent",
          agent: this.agent,
        });
        //this.agent.title = "PERSONAL CRUISE CONSULTANT";
        this.agent.callmeAt = "PLEASE CALL ME AT:";
      }
    } else {
      this.agent = {
        brand: true,
        callmeAt: "PLEASE CALL US AT:",
        phoneNumber: "+1(877)416-9722",
        website: "https://ncl.com",
      };
    }
  },
  methods: {
    onclickPhoneLink() {
      // e.preventDefault();
      window.sendEventToGA({
        event: "click_phone_link",
        agent: this.agent,
      });
      // window.location.href = `tel:${this.agent.phoneNumber}`;
    },
    onclickEmailLink() {
      // e.preventDefault();
      window.sendEventToGA({
        event: "click_email_link",
        agent: this.agent,
      });
      // window.location.href = `tel:${this.agent.phoneNumber}`;
    },
    onclickWebSiteLink() {
      // e.preventDefault();
      window.sendEventToGA({
        event: "click_website_link",
        agent: this.agent,
      });
      // window.location.href = `tel:${this.agent.phoneNumber}`;
    },
    scrollto(position) {
      anime({
        targets: "#scrollArea" + this.page + " .q-scrollarea__container",
        scrollTop: position,
        duration: 500,
        delay: 800,
        easing: "easeInOutQuad",
        changeComplete: () => {},
      });
    },
    transition() {
      if (this.page === 0) {
        this.scrollto(0);
      } else {
        const maxScrollPosition = (window.innerWidth * 437) / 948;

        this.scrollto(maxScrollPosition * 0.52);
      }
    },
    show_agent_card() {
      window.sendEventToGA({
        event: "click_agent_card_btn",
        agent: this.agent,
      });
      this.showAgentCard = true;
    },
    homeClick() {
      window.sendEventToGA({
        event: "click_home_btn",
        agent: this.agent,
      });
      this.page = 0;
      this.right = false;
    },
    menuClick(item) {
      window.sendEventToGA({
        event: "click_menu_item_btn",
        agent: this.agent,
        item: item.title,
      });
      this.page = item.index;
      this.right = false;
    },
    next() {
      this.page++;
      if (this.page > this.cards.length) this.page = 1;
    },
    previous() {
      this.page--;
      if (this.page <= 0) this.page = 0;
    },
    async share() {
      window.sendEventToGA({
        event: "click_share_link_btn",
        agent: this.agent,
      });
      const url =
        this.agent?.link && this.agent.link.length > 0
          ? this.agent.link
          : document.location;
      const shareObj = {
        url: url,
      };
      if (navigator.canShare && navigator.canShare(shareObj)) {
        try {
          await navigator.share(shareObj);
        } catch (err) {
          // alert("cant share");
        }
      } else {
        await navigator.clipboard.writeText(url);
        $q.notify({
          message: "Link was copied to clipboard",
          position: "top",
          timeout: 1500,
        });
      }
    },
  },
  setup() {
    $q = useQuasar();
  },
};
</script>

<style>
a,
a:visited {
  font-size: 20px;
  color: #0071a6;
}
</style>
